// extracted by mini-css-extract-plugin
export var scrollbar = "scrollbar___jr6jt";
export var scrollX = "scrollX___Sl97k scrollbar___jr6jt";
export var scrollY = "scrollY___ssjrS scrollbar___jr6jt";
export var scroll = "scroll___bE6i8 scrollX___Sl97k scrollbar___jr6jt scrollY___ssjrS scrollbar___jr6jt";
export var scrollableContainer = "scrollableContainer___PVhLw";
export var scrollableContainerX = "scrollableContainerX___j50kK scrollableContainer___PVhLw scrollX___Sl97k scrollbar___jr6jt";
export var scrollableContainerY = "scrollableContainerY___mOGjU scrollableContainer___PVhLw scrollY___ssjrS scrollbar___jr6jt";